export default __webpack_public_path__ + "static/media/download.0710d412.jpeg";